"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
class Form {
    constructor(parent, validateFunction, errorCodeProxy) {
        this.parent = parent;
        this.validateFunction = validateFunction;
        this.errorCodeProxy = errorCodeProxy;
    }
    get fields() {
        return this.parent.state.fields;
    }
    setFieldValue(fieldName, valueUpdateFunction) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise(resolve => this.parent.setState(p => ({
                fields: Object.assign(Object.assign({}, p.fields), { [fieldName]: valueUpdateFunction(p.fields[fieldName]) })
            }), () => resolve()));
        });
    }
    getFieldConfig(fieldName) {
        return {
            value: () => this.parent.state.fields[fieldName],
            setValue: valueUpdateFunction => this.setFieldValue(fieldName, valueUpdateFunction),
            errors: this.parent.state.fieldErrors
                .filter(e => e.fieldName === fieldName)
                .map(e => (Object.assign(Object.assign({}, e), { code: !!this.errorCodeProxy ? this.errorCodeProxy(e.code) : e.code })))
            // .map((e) =>  (!!this.errorCodeProxy ? this.errorCodeProxy(e.code) : e.code)),
        };
    }
    validate() {
        return __awaiter(this, void 0, void 0, function* () {
            let errors = [];
            if (!!this.validateFunction) {
                errors = yield this.validateFunction(this.fields);
            }
            console.log(errors);
            this.setErrors(errors);
            return errors.length === 0;
        });
    }
    setErrors(errors, removeOnly, removeFieldNameOnly) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise(resolve => this.parent.setState(p => {
                if (!removeOnly) {
                    return { fieldErrors: errors };
                }
                return {
                    fieldErrors: p.fieldErrors.filter(e => {
                        if (!removeFieldNameOnly) {
                            return errors.findIndex(x => x.code === e.code) !== -1;
                        }
                        else {
                            return (e.fieldName !== removeFieldNameOnly ||
                                errors.findIndex(x => x.code === e.code && x.fieldName === removeFieldNameOnly) !== -1);
                        }
                    })
                };
            }));
        });
    }
}
exports.Form = Form;
//# sourceMappingURL=Form.js.map